
import React from 'react';

const EligibilitySection: React.FC = () => {
  const requirements = [
    {
      icon: 'ri-calendar-line',
      title: 'Ages 28-38',
      description: 'Mature enough to match her life stage and ambitions'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Professionally Ambitious',
      description: 'She didn\'t build this career to date down - bring your A-game'
    },
    {
      icon: 'ri-heart-line',
      title: 'Family-Oriented',
      description: 'Non-negotiable - the Geraghtys are an incredible family and family comes first'
    },
    {
      icon: 'ri-passport-line',
      title: 'Valid Passport',
      description: 'Ready to explore the world together - half of it is still waiting'
    },
    {
      icon: 'ri-target-line',
      title: 'Ready for Something Real',
      description: 'No games, no casual dating - serious intentions only'
    }
  ];

  const bonusPoints = [
    {
      icon: 'ri-map-pin-line',
      title: 'Northern California Ties',
      description: 'Her amazing family would love to have her close to home'
    },
    {
      icon: 'ri-group-line',
      title: 'Great Family Background',
      description: 'You understand the value of strong family bonds and traditions'
    },
    {
      icon: 'ri-compass-line',
      title: 'Surprising Travel Stories',
      description: 'You\'ve been somewhere that changed your perspective'
    },
    {
      icon: 'ri-building-line',
      title: 'Boardroom & BBQ Comfortable',
      description: 'Equally at ease in C-suite meetings and family gatherings'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Can Keep Up',
      description: 'Ready to match the pace of someone who runs a CEO\'s world'
    }
  ];

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Who Should Apply
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            Lexi comes from an incredible family and knows what she's looking for. Here's what matters to her.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16">
          {/* Requirements */}
          <div>
            <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center">
              <div className="w-8 h-8 bg-slate-900 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-checkbox-line text-white"></i>
              </div>
              Requirements
            </h3>
            <div className="space-y-6">
              {requirements.map((req, index) => (
                <div key={index} className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
                  <div className="flex items-start space-x-4">
                    <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${req.icon} text-slate-700 text-lg`}></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-slate-900 mb-2">
                        {req.title}
                      </h4>
                      <p className="text-slate-600 leading-relaxed">
                        {req.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Bonus Points */}
          <div>
            <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center">
              <div className="w-8 h-8 bg-amber-600 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-star-line text-white"></i>
              </div>
              Bonus Points
            </h3>
            <div className="space-y-6">
              {bonusPoints.map((bonus, index) => (
                <div key={index} className="bg-white rounded-xl p-6 shadow-sm border border-amber-200">
                  <div className="flex items-start space-x-4">
                    <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${bonus.icon} text-amber-600 text-lg`}></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-slate-900 mb-2">
                        {bonus.title}
                      </h4>
                      <p className="text-slate-600 leading-relaxed">
                        {bonus.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-200 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-slate-900 mb-4">
              Meet the Criteria?
            </h3>
            <p className="text-slate-600 mb-6">
              If you're nodding along to these requirements, Lexi wants to hear from you.
            </p>
            <button 
              onClick={() => document.getElementById('application')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-slate-900 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-slate-800 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap"
            >
              Submit Your Application
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EligibilitySection;
